/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AssetDailyCandlesSearchDto } from '../models/AssetDailyCandlesSearchDto';
import type { AssetDtoPaginationResultDto } from '../models/AssetDtoPaginationResultDto';
import type { AssetGroupDtoCollectionContainerDto } from '../models/AssetGroupDtoCollectionContainerDto';
import type { AssetGroupType } from '../models/AssetGroupType';
import type { AssetInfoDto } from '../models/AssetInfoDto';
import type { CandleDto } from '../models/CandleDto';
import type { ChartHistoryDto } from '../models/ChartHistoryDto';
import type { ChartPeriodDto } from '../models/ChartPeriodDto';
import type { FavoriteAssetsDto } from '../models/FavoriteAssetsDto';
import type { CancelablePromise } from '../../../core/CancelablePromise';
import type { BaseHttpRequest } from '../../../core/BaseHttpRequest';
export class AssetsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param requestBody
     * @returns CandleDto Success
     * @throws ApiError
     */
    public postV1AssetsDailyCandlesSearch(
        requestBody?: AssetDailyCandlesSearchDto,
    ): CancelablePromise<Record<string, Array<CandleDto>>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/assets/daily-candles/search',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param asset
     * @returns AssetInfoDto Success
     * @throws ApiError
     */
    public getV1AssetsInfo(
        asset: string,
    ): CancelablePromise<AssetInfoDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/assets/{asset}/info',
            path: {
                'asset': asset,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param group
     * @param symbols
     * @param page
     * @param count
     * @returns AssetDtoPaginationResultDto Success
     * @throws ApiError
     */
    public getV1Assets(
        group?: AssetGroupType,
        symbols?: Array<string>,
        page: number = 1,
        count: number = 100,
    ): CancelablePromise<AssetDtoPaginationResultDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/assets',
            query: {
                'group': group,
                'symbols': symbols,
                'page': page,
                'count': count,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns AssetGroupDtoCollectionContainerDto Success
     * @throws ApiError
     */
    public getV1AssetsGroups(): CancelablePromise<AssetGroupDtoCollectionContainerDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/assets/groups',
        });
    }
    /**
     * @returns FavoriteAssetsDto Success
     * @throws ApiError
     */
    public getV1AssetsFavorites(): CancelablePromise<FavoriteAssetsDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/assets/favorites',
        });
    }
    /**
     * @param asset
     * @returns any Created
     * @throws ApiError
     */
    public postV1AssetsFavorites(
        asset: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/assets/favorites/{asset}',
            path: {
                'asset': asset,
            },
            errors: {
                405: `Method Not Allowed`,
            },
        });
    }
    /**
     * @param asset
     * @returns void
     * @throws ApiError
     */
    public deleteV1AssetsFavorites(
        asset: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v1/assets/favorites/{asset}',
            path: {
                'asset': asset,
            },
            errors: {
                405: `Method Not Allowed`,
            },
        });
    }
    /**
     * @param asset
     * @param candlesCount
     * @param to
     * @param from
     * @param period
     * @returns ChartHistoryDto Success
     * @throws ApiError
     */
    public getV1AssetsChartHistory(
        asset: string,
        candlesCount?: number,
        to?: string,
        from?: string,
        period?: ChartPeriodDto,
    ): CancelablePromise<ChartHistoryDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/assets/{asset}/chart-history',
            path: {
                'asset': asset,
            },
            query: {
                'candlesCount': candlesCount,
                'to': to,
                'from': from,
                'period': period,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }
}
